module.exports = __webpack_public_path__ + "static/media/051-cayman-islands.d0b49eca.svg";